import { APIPath } from 'utility/constant'
import { CRUDService } from './crud'
import { CommonUtility } from 'utility/common'
import { BaseService } from './base'

class Videos extends CRUDService {
  constructor() {
    super(APIPath.videos) // Initialize CRUDService with Videoss API path
  }

  get(params) {
    const url = `${APIPath.adminVideos}?${CommonUtility.objectToParams(params)}`
    return BaseService.get(url)
  }

  getVideoByUserId(id,filter) {
    const url = `${APIPath.videos}/user/${id}?${CommonUtility.objectToParams(
      filter,
    )}`
    return BaseService.get(url)
  }

  flagged(params) {
    const url = `${APIPath.adminFlaggedVideos}?${CommonUtility.objectToParams(
      params,
    )}`
    return BaseService.get(url)
  }

  deleted(params) {
    const url = `${APIPath.adminDeletedVideos}?${CommonUtility.objectToParams(
      params,
    )}`
    return BaseService.get(url)
  }

  toggleBlock(id, active) {
    const url = `${APIPath.adminVideos}/${id}/toggle-block`
    return BaseService.put(url, { active })
  }

  resolveFlaggedVideo(data) {
    const url = `${APIPath.videoAdmin}/resolve`
    return BaseService.put(url,data)
  }

  getDashBoardData(params) {
    const url = `${APIPath.dashBoard}?${CommonUtility.objectToParams(
      params,
    )}`
    return BaseService.get(url)
  }

}

// Initialize the service with the desired API path
const VideosService = new Videos(APIPath.videos)
Object.freeze(VideosService)

export { VideosService }
